import React from 'react';

import PropTypes from 'prop-types';
import { isEmpty } from 'lodash';

import { Button, ButtonCounter } from 'modules/common/input';
import { toastWarning } from 'modules/common/toast';

import Addons from '../components/Addons';
import Variants from '../components/Variants';

const DEFAULT_FORM = {
  selected_variant: {},
  selected_addons: [],
  quantity: 1,
};

function OrderDetailsModal({
  productExistsIndex,
  data,
  onChange,
  onClose,
  cart,
  type,
  index,
}) {
  const [form, setForm] = React.useState(DEFAULT_FORM);

  const getRemaining = React.useCallback(() => {
    const productsInCart = productExistsIndex(
      {
        ...data,
        selected_variant: form?.selected_variant,
      },
      { isFilter: true }
    );
    const productsInCartQty = productsInCart?.reduce(
      (acc, item) => acc + item?.quantity,
      0
    );

    if (data?.type === 'Fixed') {
      return 1;
    }

    if (!isEmpty(form?.selected_variant)) {
      return (
        data?.variants.find(
          (item) => form?.selected_variant?.uuid === item?.uuid
        )?.remaining - productsInCartQty
      );
    }

    return data?.remaining - productsInCartQty;
  }, [data, form?.selected_variant, productExistsIndex]);

  const handleOnSubmit = () => {
    if (data?.variants?.length > 0 && isEmpty(form?.selected_variant)) {
      toastWarning('Please, select a variant to proceed.');
      return;
    }

    if (getRemaining() <= 0) {
      toastWarning(`${getRemaining()} stock(s) left`);
      return;
    }

    const args = () => {
      if (!isEmpty(form?.selected_variant)) {
        return {
          ...form,
          price: form?.selected_variant?.final_price,
        };
      }

      return {
        ...form,
        price: form?.final_price,
      };
    };

    onChange(args(), {
      index,
      type,
    });
    onClose();
  };

  React.useEffect(() => {
    setForm({ ...DEFAULT_FORM, ...data });
  }, [data]);

  const variantExists = (row) =>
    cart?.filter(
      (item) =>
        item?.uuid === data?.uuid && item?.selected_variant?.uuid === row?.uuid
    );

  return (
    <>
      <hr className="border-gray-100" />

      <div className="flex-1 overflow-y-auto overflow-x-hidden space-y-5 pt-5">
        <Variants
          form={form}
          setForm={setForm}
          variantExists={variantExists}
          data={data}
        />

        <hr className="border-gray-100" />

        <Addons form={form} setForm={setForm} />
      </div>

      <div className="flex items-center gap-2">
        <div>
          <ButtonCounter
            name="quantity"
            value={form?.quantity}
            onChange={setForm}
            buttonClassName="!p-3.5 !rounded"
            numberClassName="text-2xl min-w-[35px]"
            iconClassName="!h-4 !w-4"
            autoWidth
            {...(data?.type !== 'Fixed'
              ? {
                  max: getRemaining(),
                  maxDescription: `${getRemaining()} stock(s) left`,
                  disabledDescription:
                    (data?.has_variant &&
                      isEmpty(form?.selected_variant) &&
                      'Please select a variant first') ||
                    (getRemaining() <= 0 && `${getRemaining()} stock(s) left`),
                  disabled:
                    (data?.has_variant && isEmpty(form?.selected_variant)) ||
                    getRemaining() <= 0,
                }
              : {})}
          />
        </div>

        <div className="flex-1">
          <Button
            label={`${type === 'UPDATE' ? 'Update' : 'Add to'} Order`}
            className="btn primary font-semibold w-full"
            onClick={handleOnSubmit}
          />
        </div>
      </div>
    </>
  );
}

OrderDetailsModal.defaultProps = {
  data: {},
  cart: [],
  onClose: () => {},
  onChange: () => {},
  // productExistsCondition: () => {},
  productExistsIndex: () => {},
  index: -1,
  type: 'CREATE',
};

OrderDetailsModal.propTypes = {
  data: PropTypes.instanceOf(Object),
  cart: PropTypes.instanceOf(Array),
  onClose: PropTypes.instanceOf(Function),
  onChange: PropTypes.instanceOf(Function),
  productExistsIndex: PropTypes.instanceOf(Function),
  // productExistsCondition: PropTypes.instanceOf(Function),
  index: PropTypes.number,
  type: PropTypes.string,
};

export default OrderDetailsModal;
